<template>
    <a-modal :title="`${props.tableColumnsData.full_name}控制台`" :width="1300" :open="true" @ok="onFormSubmit" @cancel="
        () => {
            emit('cancel')
        }
    ">
        <!-- 自定义footer -->
        <template #footer>
            <a-button key="back" @click="
                () => {
                    emit('cancel')
                }
            ">
                取消
            </a-button>
            <a-button key="submit" type="primary" @click="onFormSubmit" ref="ref5"> ③ 提交订单 </a-button>
        </template>
        <a-form @finish="onFinish" v-bind="formLayout" :model="formState">
            <a-form-item label="核验方式">
                <a-radio-group v-model:value="type" button-style="solid">
                    <a-radio-button :value="1">自动核验</a-radio-button>
                    <a-radio-button :value="3" ref="ref4">人工核验</a-radio-button> </a-radio-group><a
                    @click="onHistoryClick" style="margin-left: 20px; line-height: 50px">查看历史审核日志</a>
            </a-form-item>
            <a-table :loading="data.ownershipTableLoading" size="small" v-show="type == 1" style="margin-bottom: 10px"
                :scroll="{ x: true }" :columns="columns" rowKey="name" :data-source="shareOwnershipTableData"
                :pagination="false">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'name'">
                        <span>{{ record.name }}</span>
                    </template>
                    <template v-else-if="column.dataIndex === 'id_card_number'">
                        <div>{{ record.id_card_number }}</div>
                        <div>{{ record.address }}</div>
                        <a-button v-if="!record.showIdCard" @click="record.showIdCard = true"
                            style="display: block; padding: 0" type="link">查看身份证照片</a-button>
                        <div v-if="record.showIdCard">
                            <a-image :width="100" :src="$store.state.user.image_domain + record.id_card_back"></a-image>
                            <a-image :width="100"
                                :src="$store.state.user.image_domain + record.id_card_front"></a-image>
                        </div>
                    </template>
                    <template v-else-if="column.dataIndex === 'phone_number'">
                        <div v-if="record.isEdit">
                            <a-input style="width: 130px; margin-bottom: 5px" v-model:value="record.phone_number"
                                @change="
                                    (v) => {
                                        phoneChange(v, 'phone_number', record)
                                    }
                                " placeholder="请输入手机号码" name="phone_number"></a-input>
                            <div>
                                <a-button class="mr-2x" @click="queryDetail()" size="small">取消</a-button>
                                <a-button @click="editPhoneChange(record)" size="small" type="primary">确认</a-button>
                            </div>
                        </div>
                        <span v-else @click="editPhone(index)" class="pointer phone_number">{{ record.phone_number ||
                            '无' }}
                            <a-tag v-if="index == shareOwnershipTableData[0]['sign_status_index']" ref="ref3"
                                style="border: none; background: none">
                                <EditOutlined />
                            </a-tag>
                            <EditOutlined v-else />
                        </span>
                        <a-popover title="手机号码出现的主体列表" trigger="click" v-if="record.affiliatedCompany_len > 0"
                            placement="right">
                            <template #content>
                                <a-table size="small" :dataSource="record.affiliatedCompany_list" :columns="[
                                    {
                                        title: '公司名称',
                                        dataIndex: 'full_name',
                                        key: 'full_name'
                                    }
                                ]" />
                            </template>
                            <a-tag color="red" style="cursor: pointer; font-size: 12px">关联主体:{{
                                record.affiliatedCompany_len
                            }}家,点击查看</a-tag>
                        </a-popover>
                    </template>
                    <template v-else-if="column.dataIndex === 'sign_status'">
                        <span style="display: flex; align-items: center" v-if="record.is_sign_show == 1">
                            <a-tag :color="text == '未签字' ? 'red' : 'cyan'">① {{ text }} </a-tag>
                            <a-image v-if="text == '已签字'" :width="70" :src="record.signature_url" />
                            <a-popconfirm v-if="text == '已签字'" title="确定退回签字?" @confirm="backSignature(record)">
                                <a v-if="text == '已签字'">退回重签</a>
                            </a-popconfirm>
                            <a-popover v-else>
                                <template #content>
                                    <div class="m-x">
                                        <a-qrcode :bordered="false"
                                            :value="'http://console.cskaiyela.com/m/pages/signature/index?id=' + props.tableColumnsData.id" />
                                    </div>
                                </template>
                                <a-button ref="ref1" v-if="index == shareOwnershipTableData[0]['sign_status_index']"
                                    type="primary" size="small">① 点击签字</a-button>
                                <a-button v-else type="primary" size="small">① 点击签字</a-button>
                            </a-popover>
                        </span>
                        <span v-else> - </span>
                    </template>
                    <template v-else-if="column.dataIndex === 'hyflag'">
                        <span v-if="record.hyflag.shiming">
                            <a-tag class="positionItem" :color="record.hyflag.shiming.color == 1 ? 'cyan' : 'red'">{{
                                record.hyflag.shiming.title }} All:{{ record.hyflag.shiming.all }}，√:{{
                                    record.hyflag.shiming.success }}，x:{{ record.hyflag.shiming.fail }}</a-tag>
                        </span>
                        <span class="positionItem" v-if="record.hyflag.online">
                            <a-tag :color="record.hyflag.online.color == 1 ? 'cyan' : 'red'">{{
                                record.hyflag.online.title }} All:{{ record.hyflag.online.all }}，√:{{
                                    record.hyflag.online.success }}，x:{{ record.hyflag.online.fail }}</a-tag>
                        </span>
                        <span v-if="record.hyflag.verify">
                            <a-tag class="positionItem" :color="record.hyflag.verify.color == 1 ? 'cyan' : 'red'">{{
                                record.hyflag.verify.title }} All:{{ record.hyflag.verify.all }}，√:{{
                                    record.hyflag.verify.success }}，x:{{ record.hyflag.verify.fail }}</a-tag>
                        </span>
                    </template>
                    <template v-else-if="column.dataIndex === 'position_ids'">
                        <div v-if="record.joblist && record.joblist.length > 0">
                            <a-tag class="positionItem" :color="item.name == '法定代表人' ? 'red' : 'cyan'"
                                v-for="(item, index) in record.joblist" :key="index">
                                {{ item.name }}
                            </a-tag>
                        </div>
                        <div v-else>无</div>
                    </template>
                    <template v-else-if="column.dataIndex === 'options'">
                        <a-popover title="核验操作日志" placement="left" trigger="click"
                            overlayClassName="order-verification-popover"
                            @openChange="(val) => onVerificationClick(val, record, index)">
                            <template #content>
                                <a-spin tip="更新数据中" :spinning="verificationLoading">
                                    <a-table style="width: 700px" :columns="verificationColumns" rowKey="id"
                                        :pagination="false" :data-source="heyanBenrentelData">
                                        <template #bodyCell="{ column, record, index, text }">
                                            <template v-if="column.dataIndex == 'mobile'">
                                                {{ record.text }}
                                                {{ record.mobile }}
                                                <a-popover trigger="click" overlayClassName="customer-options-popover">
                                                    <template #content>
                                                        <a-table style="width: 400px"
                                                            :columns="affiliatedCompanyColumns" rowKey="id"
                                                            :pagination="false" :data-source="record.affiliatedCompany"
                                                            size="small">
                                                            <template #bodyCell="{ column1, record1, index1, text1 }">
                                                            </template>
                                                        </a-table>
                                                    </template>
                                                    <span><a v-if="record.affiliatedCompany_len > 0"> 查看关联（{{
                                                        record.affiliatedCompany_len }}）</a></span>
                                                </a-popover>
                                            </template>
                                            <template v-if="column.dataIndex == 'res_status'">
                                                <a-tag color="cyan" v-if="record.res_status == 1"> 通过√ </a-tag>
                                                <a-tag color="red" v-else> 未通过× </a-tag>
                                            </template>
                                        </template>
                                    </a-table>
                                    <div v-if="telusedminrequired > 0 && heyanBenrentelData.length > 0"
                                        style="margin-top: 10px">
                                        <!-- <div v-if="verificationDisabled()">
                      <a-tag color="red">实名核验有误不能核验手机号码使用时间</a-tag>
                    </div>
                    <div v-else> -->
                                        <a-button type="primary" style="float: right; margin-top: 5px"
                                            @click="onVerificationPhoneClick(record, index)"
                                            :loading="data.verifyPhoneLoading"> 核验手机号码使用时间 </a-button>
                                        <p>
                                            说明：<br /><a-tag
                                                color="green">1：核验结果显示“实名校验通过”则代表手机号码是本人的，实名认证通过√</a-tag><Br />
                                            <a-tag color="green">2：核验结果显示“24+”则代表手机号码使用超过了24个月，使用时间通过√</a-tag><br />
                                            <a-tag color="green">3：(该平台手机号使用时间需要满足{{ telusedminrequired }}月以上)</a-tag>
                                        </p>
                                        <!-- </div> -->
                                    </div>
                                </a-spin>
                            </template>
                            <a-button ref="ref2" v-if="index == shareOwnershipTableData[0]['sign_status_index']"
                                type="primary" size="small">②
                                过风控</a-button>
                            <a-button v-else type="primary" size="small">② 过风控</a-button>
                        </a-popover>
                    </template>
                </template>
            </a-table>
            <a-form-item label="说明" v-show="type == 2">
                <span>支付宝搜索</span>
            </a-form-item>
            <div v-if="type == 3" :key="data.key">
                <a-form-item label="核验资料说明">
                    <div>
                        <a-textarea class="mb-1x" v-model:value="formState.statement" placeholder="请输入核验资料说明" auto-size
                            style="width: 400px" />
                    </div>
                    <div>
                        <a @click="
                            () => {
                                formState.statement = '手持承诺书拍照'
                            }
                        " class="mr-2x">手持承诺书拍照</a><a @click="
                            () => {
                                formState.statement = '代理记账合同'
                            }
                        ">代理记账合同</a>
                    </div>
                </a-form-item>
                <a-form-item label="其他资料核验">
                    <Upload :upload_path="props.tableColumnsData.upload_path"
                        :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png', 'mp4', 'mp3']" @uploading="
                            (val) => {
                                data.finishLoading = val
                            }
                        " :customerName="props.tableColumnsData.entityNameToRegister.full_name" uploadType="text"
                        v-model:value="formState.urls" :limitation="99" :imgLimitSize="10" uploadText="上传其他资料">
                    </Upload>
                    <span>说明：其他资料可以是代理记账合同，或者其他你认为可以消除疑点的资料，只要确定他不是卖发票的，不是洗钱的动机即可，整体来讲就是要排除此次注册行为，消除疑点即可。</span>
                    <div>
                        <p>以下方式，任选其一：</p>
                        <p>
                            1：采用手持承诺书过风控； <a @click="onDocxClick">
                                <VerticalAlignBottomOutlined /> 范本.docx
                            </a><span>要求看到人的半身，左右手臂完全入镜</span>
                        </p>
                        <p>2：拍摄视频验证； 大致差不多即可。文案："<span
                                style="color: #1677ff">我承诺办理的长沙xxxx公司营业执照，是本人真实意愿的表达，合法经营，特此声明</span>"
                        </p>
                    </div>
                </a-form-item>
                <a-form-item :wrapper-col="{ offset: 7, span: 16 }">
                    <a-button type="primary" class="mr-2x" :loading="data.finishLoading" :disabled="data.finishLoading"
                        html-type="submit">提交审核</a-button>
                </a-form-item>
                <a-table v-if="false" :loading="data.verificationTableLoading" style="margin-bottom: 10px"
                    :columns="verificationDataColumns" rowKey="name" :data-source="data.verificationData"
                    :pagination="false">
                    <template #bodyCell="{ column, record, index, text }">
                        <template v-if="column.dataIndex === 'name'">
                            <span>{{ record.name }}</span>
                        </template>
                        <template v-else-if="column.dataIndex === 'id_card_number'">
                            <span>{{ record.id_card_number }}</span>
                        </template>
                    </template>
                </a-table>
            </div>
        </a-form>
        <p class="remark" style="font-size: 16px">提交订单说明: 完成①签字②过风控③提交订单即可</p>
        <a-modal :title="`${props.tableColumnsData.full_name}变更登录`" :keyboard="false" :maskClosable="false" :width="800"
            :open="data.openQrcode" :footer="null" @cancel="qrcodeCancel">
            <a-form @finish="onRegisterFinish" v-bind="formLayout" :model="registerFormState" :rules="rules">
                <a-form-item label="核验方式">
                    <a-radio-group v-model:value="registerFormState.type" button-style="solid">
                        <a-radio :value="1">短信验证码登录</a-radio>
                        <a-radio :value="2">授权登录</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="扫码登录" v-show="registerFormState.type == 2">
                    <div class="d-flex flex-left" v-show="data.deadline > 0">
                        <img :src="data.qrcode" />
                        <a-statistic-countdown format="mm:ss" title="登录倒计时" :value="data.deadline"
                            @finish="onStatisticFinish" />
                    </div>
                    <div v-show="data.deadline == 0">
                        <a-button type="primary" @click="onFormSubmit">重新获取</a-button>
                    </div>
                </a-form-item>
                <div v-if="registerFormState.type == 1">
                    <a-form-item label="统一社会信用代码" name="social_credit_code" required>
                        <a-input v-model:value="registerFormState.social_credit_code" placeholder="请输入统一社会信用代码">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="联络员姓名" name="name" required v-if="registerFormState.name">
                        <a-input v-model:value="registerFormState.name" :disabled="true"> </a-input>
                    </a-form-item>
                    <a-form-item label="联络员身份证号码" name="id_card_number" required>
                        <a-input v-model:value="registerFormState.id_card_number" placeholder="联络员身份证号码"> </a-input>
                    </a-form-item>
                    <a-form-item label="联络员电话号码" name="phone_number">
                        <a-input v-model:value="registerFormState.phone_number" placeholder="请输入联络员电话号码"
                            :disabled="true">
                        </a-input>
                    </a-form-item>
                    <a-form-item label="验证码" required>
                        <div class="d-flex">
                            <a-input v-model:value="registerFormState.code" placeholder="请输入验证码"> </a-input><a-button
                                type="primary" class="ml-1x" @click="onGetCodeClick"
                                :disabled="data.getCodeDisabled">获取验证码</a-button>
                        </div>
                    </a-form-item>
                    <a-form-item label="请勾选变更事项" required>
                        <a-checkbox-group v-model:value="data.changetype">
                            <a-checkbox value="1">地址变更</a-checkbox>
                            <a-checkbox value="2" name="changetype">经营范围变更</a-checkbox>
                        </a-checkbox-group>
                    </a-form-item>
                    <a-form-item label="最终动作" required v-if="user.id == 1">
                        <a-radio-group v-model:value="data.changeactionlast">
                            <a-radio :value="1">提交</a-radio>
                            <a-radio :value="2">暂存</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :wrapper-col="{ offset: 7, span: 16 }">
                        <a-button type="primary" html-type="submit">确定</a-button>
                    </a-form-item>
                </div>
            </a-form>
        </a-modal>
        <a-modal title="历史审核记录" :width="1200" :bodyStyle="{ padding: '30px' }" :open="data.openHistory" :footer="null"
            @cancel="historyCancel">
            <a-table :loading="data.historyLoading" :columns="historyColumns" :data-source="data.historyList"
                :pagination="false">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'name'">
                        {{ record.customer_info?.full_name }}
                    </template>
                    <template v-else-if="column.dataIndex === 'verification'">
                        <a-tag color="blue" v-if="record.status_name == '待审核'">{{ record.status_name }}</a-tag>
                        <a-tag color="green" v-else-if="record.status_name == '审核通过'">{{ record.status_name }}</a-tag>
                        <a-tag color="red" v-else>{{ record.status_name }}</a-tag>
                        <div v-if="record.reason">理由:{{ record.reason }}</div>
                    </template>
                    <template v-else-if="column.dataIndex === 'statement'">
                        <div style="max-width: 200px">
                            {{ text?.length > 0 ? text : '-' }}
                        </div>
                    </template>
                    <template v-else-if="column.dataIndex === 'updated_at'">
                        <div v-if="record.status_name != '待审核'">{{ record.operator_admin_info?.nickname }}{{ text
                        }}审核完毕,耗时{{ calculateTimeDifference(record.created_at, record.updated_at) }}</div>
                        <div v-else>-</div>
                    </template>
                    <template v-else-if="column.dataIndex === 'urls'">
                        <div style="flex-wrap: wrap; gap: 10px 10px" class="d-flex" v-if="text?.length > 0">
                            <span v-for="(item, index) in text">
                                <a-image
                                    v-if="item.name.indexOf('jpg') > -1 || item.name.indexOf('png') > -1 || item.name.indexOf('jpeg') > -1"
                                    :key="index" :width="100" :height="100"
                                    :src="$store.state.user.image_domain + item.url">
                                </a-image>
                                <p v-else>
                                    <a :href="$store.state.user.image_domain_a + item.url" download target="_blank">{{
                                        item.name }}</a>
                                </p>
                            </span>
                        </div>
                        <div v-else>-</div>
                    </template>
                </template>
            </a-table>
        </a-modal>
        <a-modal :open="data.openPushOrder" @cancel="
            () => {
                data.openPushOrder = false
            }
        " @ok="handlePushOrder" :confirmLoading="data.confirmLoading" :maskClosable="false" :keyboard="false"
            :closable="false" okText="提交订单">
            <template #title>
                <div class="modal-title">
                    <InfoCircleOutlined class="InfoCircleOutlined" />
                    <span class="title"
                        v-if="props.tableColumnsData.business_type == 2 && props.tableColumnsData.main_type == 1"> 拟变更事项
                    </span>
                    <span class="title" v-else> 电子化录单告知书 </span>
                </div>
            </template>
            <p v-if="props.tableColumnsData.business_type == 2 && props.tableColumnsData.main_type == 1">
                <a-form-item label="请勾选变更事项">
                    <a-checkbox-group v-model:value="data.changetype">
                        <a-checkbox value="1" disabled="false">地址变更</a-checkbox>
                        <a-checkbox value="2">经营范围变更</a-checkbox>
                    </a-checkbox-group>
                </a-form-item>
                <a-form-item label="最终动作" required v-if="user.id == 1">
                    <a-radio-group v-model:value="data.changeactionlast">
                        <a-radio :value="1">提交</a-radio>
                        <a-radio :value="2">暂存</a-radio>
                    </a-radio-group>
                </a-form-item>
            </p>
            <p v-else>注册大概需要15~30分钟，不要催，资料员按先后顺序来做单！</p>
        </a-modal>
    </a-modal>
    <a-tour v-model:current="current" :open="open" :steps="steps" @close="handleOpen(false)" />
</template>
<script lang="ts" setup>
import { reactive, onMounted, toRefs, h, ref, createVNode } from 'vue'
import Upload from '@/components/base/Upload.vue'
import { message, Modal } from 'ant-design-vue'
import { EditOutlined, VerticalAlignBottomOutlined, EllipsisOutlined } from '@ant-design/icons-vue'
import baseService from '@/utils/http/axios'
import { mobileRequiredValidator } from '@/utils/util'
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import { useStore } from 'vuex'
import ls from '@/utils/Storage'
const user = ls.get('USER_INFO')
import dayjs from 'dayjs'
const $store = useStore()
import type { TourProps } from 'ant-design-vue'
const open = ref<boolean>(false)
const ref1 = ref(null)
const ref2 = ref(null)
const ref3 = ref(null)
const ref4 = ref(null)
const ref5 = ref(null)
const current = ref(0)
const steps: TourProps['steps'] = [
    {
        title: '第一步：签字',
        description: createVNode('div', { style: 'text-align: left;' }, [
            createVNode('p', null, '鼠标移动到这里，微信扫描二维码可以签字。'),
            createVNode('p', { style: 'color: #ff4d4f; margin-top: 8px;' }, '注意：出现签字按钮的每一个人都要签字！')
        ]),
        target: () => ref1.value?.$el
    },
    {
        title: '第二步：过风控，核验',
        description: createVNode('div', { style: 'text-align: left;' }, [
            createVNode('p', null, '核验通过条件：'),
            createVNode('ul', { style: 'padding-left: 16px; margin: 8px 0;' }, [
                createVNode('li', { style: 'line-height:24px; margin: 8px 0;' }, '✅任意一个人员姓名、身份证号码、手机号码一致（部分平台还要求手机号码满足使用至少12个月）【快速通过】'),
                createVNode('li', { style: 'line-height:24px; margin: 8px 0;' }, '✅如果法人代表是外省的，则需要其手持承诺书拍照上传审核，人工审核【快速通过】'),
                createVNode('li', { style: 'line-height:24px; margin: 8px 0;' }, '✅如果股东中有本地人，提交资料到人工核验，本地人可【快速免检通过】'),
                createVNode('li', { style: 'line-height:24px; margin: 8px 0;' }, '✅任意2个股东的住址完全相同的，提交人工核验【快速免检通过】'),
                createVNode('li', { style: 'line-height:24px; margin: 8px 0;' }, '✅一些工作、开会等的照片，显示其实际经营的证据的，提交【人工核验】，等待审核通过'),
                createVNode('li', { style: 'line-height:24px; margin: 8px 0;' }, '✅股东天南海北的、年龄过大过小的，一般无法入驻，除非提供实际经营的证据，证据提交【人工核验】，等待审核通过'),
                createVNode('li', { style: 'line-height:24px; margin: 8px 0;' }, '✅其他能证明其实际经营的证据，提交【人工核验】，等待审核通过')
            ]),
            createVNode('p', { style: 'font-weight: bold; margin-top: 8px;' }, '备注：以上核验条件任意一个通过则风控通过！')
        ]),
        target: () => ref2.value?.$el
    },
    {
        title: '风控核验如果不通过',
        description: createVNode('div', { style: 'text-align: left; max-height: 300px; overflow-y: auto;' }, [createVNode('p', null, '点击此处，修改为本人身份证开卡的手机号码即可！')]),
        target: () => ref3.value?.$el
    },
    {
        title: '这里是人工审核提交资料的地方',
        description: createVNode('div', { style: 'text-align: left; max-height: 300px; overflow-y: auto;' }, [
            createVNode('p', null, '省内用户，上传手持承诺书照片即可快速通过，省外用户需真实手机号码满足系统要求，且需要上传手持承诺书照片，等待人工审核通过！')
        ]),
        target: () => ref4.value?.$el
    },
    {
        title: '第三步：推送给资料员录单',
        description: createVNode('div', { style: 'text-align: left; max-height: 300px; overflow-y: auto;' }, [
            createVNode('p', null, '录单时间：'),
            createVNode('ul', { style: 'padding-left: 16px; margin: 8px 0;' }, [createVNode('li', null, '公司大概要20分钟才能录好'), createVNode('li', null, '个体户大概要15分钟')]),
            createVNode('p', { style: 'font-weight: bold; margin-top: 12px;' }, '希望大家不要催，按提交的先后顺序录单！'),
            createVNode('p', null, '推送的时候会先进行一些智能化的检测：'),
            createVNode('p', null, '如名称通不过会立马反馈，请留意反馈信息,如名称通不过请编辑修改公司名称保存后，再次推送！')
        ]),
        target: () => ref5.value?.$el
    }
]
const handleOpen = (val: boolean): void => {
    open.value = val
}
interface tableData {
    isEdit: boolean
}
let timer = ref()
//关闭清空
const qrcodeCancel = () => {
    data.openQrcode = false
    clearInterval(timer.value)
}

const rules = {}
const emit = defineEmits(['cancel', 'ok'])
const verificationDataColumns = [
    {
        title: '状态',
        dataIndex: 'name'
    },
    {
        title: '审核时间',
        dataIndex: 'name'
    },
    {
        title: '创建时间',
        dataIndex: 'name'
    },
    {
        title: '申请人',
        dataIndex: 'name'
    }
]
const historyColumns = [
    {
        title: '公司名称',
        dataIndex: 'name',
        width: 150
    },
    {
        title: '审核',
        dataIndex: 'verification',
        width: 150
    },
    {
        title: '其他资料',
        dataIndex: 'urls'
    },
    {
        title: '备注',
        dataIndex: 'statement',
        width: 200
    },
    {
        title: '申请时间',
        dataIndex: 'created_at',
        width: 150
    },
    {
        title: '审核时间',
        dataIndex: 'updated_at',
        width: 150
    }
]
var columns: Array<Object> = [
    {
        title: '姓名',
        dataIndex: 'name'
    },
    {
        title: '身份证号码',
        dataIndex: 'id_card_number'
    },
    {
        title: '担任职位',
        dataIndex: 'position_ids',
        width: '200px'
    },
    {
        title: '手机号码',
        dataIndex: 'phone_number',
        width: '180px'
    },

    {
        title: '签字状态',
        dataIndex: 'sign_status'
    },
    {
        title: '签字时间',
        dataIndex: 'sign_time'
    },
    {
        title: '核验状态',
        dataIndex: 'hyflag',
        width: '100px'
    },
    {
        title: '操作',
        dataIndex: 'options',
        width: 80
    }
]
const verificationColumns: Object[] = [
    {
        title: '手机号码',
        dataIndex: 'mobile',
        width: 220
    },
    {
        title: '核验详情（结果）',
        dataIndex: 'resmsg'
    },
    {
        title: '核验结果',
        dataIndex: 'res_status',
        scopedSlots: { customRender: 'res_status' }
    },
    {
        title: '核验人',
        dataIndex: 'author'
    },
    {
        title: '核验时间',
        dataIndex: 'ctime'
    }
]
const affiliatedCompanyColumns: Object[] = [
    {
        title: '公司名称',
        dataIndex: 'full_name'
    }
]
const formLayout: Object = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
    }
}
const formState = reactive<any>({
    statement: null,
    urls: null
})
const registerFormState = reactive<any>({
    code: null,
    name: '',
    id_card_number: null,
    phone_number: null,
    type: 1, //短信验证码登录
    id: null
})
interface data {
    telusedminrequired: number
    verificationLoading: boolean
    verificationTableLoading: boolean
    confirmLoading: boolean
    ownershipTableLoading: boolean
    type: number
    qrcode: string
    openQrcode: boolean
    openHistory: boolean
    historyLoading: boolean
    deadline: number
    key: number
    verificationData: any[]
    historyList: any[]
    getCodeDisabled: boolean
    finishLoading: boolean
    openPushOrder: boolean
    verifyPhoneLoading: boolean
    changetype: string[]
    changeactionlast: number
}
const data = reactive<data>({
    telusedminrequired: 0,
    verificationLoading: false,
    confirmLoading: false,
    verificationTableLoading: false,
    ownershipTableLoading: false,
    type: 1,
    qrcode: '',
    openQrcode: false,
    openHistory: false,
    deadline: 0,
    key: 1,
    historyLoading: false,
    verificationData: [],
    historyList: [],
    getCodeDisabled: false,
    finishLoading: false,
    openPushOrder: false,
    verifyPhoneLoading: false,
    changetype: ['1'],
    changeactionlast: 1
})
let heyanBenrentelData = reactive<[]>([])
let affiliatedCompany = reactive<[]>([])
const shareOwnership = ref<tableData[]>([])
let shareOwnershipTableData = shareOwnership.value
const { telusedminrequired, verificationLoading, type } = toRefs(data)

onMounted(() => {
    queryDetail()
    if (props.tableColumnsData.business_type != 1 && props.tableColumnsData.main_type == 1) {
        // getMigrateSmsCode()
    }
})
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => { }
    }
})
const backSignature = (record) => {
    let data: any = {
        customer_id: props.tableColumnsData.id,
        id: record.stockholder_id ? record.stockholder_id : record.persion_id
    }
    let requestParam = {
        url: '/admin/v1/signatureBack',
        method: 'post',
        data: data
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            queryDetail(1)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
const phoneChange = (v, type, record) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    record[type] = str
}
// 计算时间差
const calculateTimeDifference = (startDate: string, endDate: string) => {
    const start = dayjs(startDate)
    const end = dayjs(endDate)
    const duration = end.diff(start, 'minute')
    return formatDuration(duration)
}
const formatDuration = (duration: number) => {
    const days = Math.floor(duration / (24 * 60))
    const hours = Math.floor((duration % (24 * 60)) / 60)
    const minutes = duration % 60
    return `${days > 0 ? days + '天' : ''}${hours > 0 ? hours + '小时' : ''}${minutes > 0 ? minutes : 1}分钟`
}

const getMigrateSmsCode = () => {
    data.ownershipTableLoading = true
    let requestParam = {
        url: '/admin/v1/getLiaisonInfo?customer_id=' + props.tableColumnsData.id,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            registerFormState.social_credit_code = props.tableColumnsData.social_credit_code
            registerFormState.id = res.data.id
            registerFormState.name = res.data.name
            registerFormState.id_card_number = res.data.id_card_number
            registerFormState.phone_number = res.data.phone_number
            if (res.data.is_change) {
                message.warn('检测到联络员有变化,正在重新刷新列表')
                queryDetail()
            }
        })
        .catch((res) => { })
}
const historyCancel = () => {
    data.openHistory = false
}
const onHistoryClick = () => {
    data.openHistory = true
    data.historyLoading = true
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/customerDataVerificatioList',
        method: 'post',
        data: Object.assign({ page: 1, limit: 'all', name: props.tableColumnsData.full_name })
    }
    baseService(requestParam)
        .then((res) => {
            data.historyLoading = false
            data.historyList = res.data.list
        })
        .catch((res) => {
            data.historyLoading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('审核列表查询失败,请联系管理员')
            }
        })
}

const onStatisticFinish = () => {
    // data.openQrcode = false
    data.qrcode = ''
    data.deadline = 0
}
const queryDetail = (type?: number) => {
    return new Promise((resolve, reject) => {
        data.ownershipTableLoading = true
        let requestParam = {
            url: '/admin/v1/tuisongzuodan',
            method: 'post',
            data: {
                action: 'getgudonglist',
                id: props.tableColumnsData.id,
                type: type
            }
        }
        baseService(requestParam)
            .then((res: any) => {
                let list: tableData[] = res.data.map((item: any) => ({
                    ...item,
                    isEdit: false,
                    showIdCard: false
                }))
                shareOwnership.value = [...list]
                shareOwnershipTableData = shareOwnership.value
                shareOwnershipTableData.forEach((item: any) => {
                    if (item.shiming_flag == 2) {
                        //删除columns中的  {title: '核验状态',dataIndex: 'hyflag',width: '100px'}
                        columns = columns.filter((item: any) => item.dataIndex != 'hyflag' && item.dataIndex != 'options')
                    }

                    item['joblist'].forEach((item2) => {
                        if (item2.id == 1 && item.id_card_number) {
                            registerFormState.id_card_number = item.id_card_number
                            registerFormState.name = item.name
                        }
                        if (item2.id == 6 && item.id_card_number) {
                            registerFormState.id_card_number = item.id_card_number
                            registerFormState.name = item.name
                        }
                    })

                    //   console.log(item)
                })
                data.ownershipTableLoading = false
                resolve(shareOwnershipTableData)
                if (shareOwnershipTableData[0]['sign_status_index'] != -1) {
                    setTimeout(() => {
                        open.value = true
                    }, 800)
                }
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
            })
    })
}
const onGetCodeClick = () => {
    data.getCodeDisabled = true
    let requestParam = {
        url:
            '/admin/v1/getMigrateSmsCode?id_card_number=' +
            registerFormState.id_card_number +
            '&social_credit_code=' +
            registerFormState.social_credit_code +
            '&customer_id=' +
            props.tableColumnsData.id +
            '&phone_number=' +
            registerFormState.phone_number +
            '&name=' +
            registerFormState.name,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            registerFormState.name = res.data.liaisonName
            registerFormState.phone_number = res.data.tel
            message.success(res.msg)
        })
        .catch((res) => {
            data.getCodeDisabled = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取失败')
            }
        })
}
const handlePushOrder = () => {
    data.confirmLoading = true
    let requestParam = {
        url: '/admin/v1/pushOrder',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            changetype: data.changetype,
            changeactionlast: data.changeactionlast
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            data.confirmLoading = false
            message.success(res.msg)
            emit('ok')
        })
        .catch((res) => {
            data.confirmLoading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
const onFinish = () => {
    if (formState.statement || formState.urls?.length > 0) {
        data.finishLoading = true
        let requestParam = {
            url: '/admin/v1/customerDataVerificatio',
            method: 'post',
            data: {
                customer_id: props.tableColumnsData.id,
                urls: formState.urls,
                statement: formState.statement
            }
        }
        baseService(requestParam)
            .then((res: any) => {
                data.finishLoading = false
                data.key = data.key + 1
                formState.urls = []
                formState.statement = ''
                message.success(res.msg, 10)
                emit('cancel')
            })
            .catch((res) => {
                data.finishLoading = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
            })
    } else {
        message.error('请上传其他资料或者填写备注')
    }
}
// 提交验证码
const onRegisterFinish = () => {
    if (!registerFormState.code) {
        message.error('请输入验证码')
        return
    }
    let requestParam = {
        url: '/admin/v1/setMigrateSmsCode',
        method: 'post',
        data: {
            customer_id: props.tableColumnsData.id,
            verify_code: registerFormState.code,
            name: registerFormState.name,
            phone_number: registerFormState.phone_number,
            id_card_number: registerFormState.id_card_number,
            social_credit_code: registerFormState.social_credit_code
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            qrcodeCancel()
            let requestParam = {
                url: '/admin/v1/pushOrder',
                method: 'post',
                data: {
                    customer_id: props.tableColumnsData.id,
                    changetype: data.changetype,
                    changeactionlast: data.changeactionlast
                }
            }
            baseService(requestParam)
                .then((res: any) => {
                    message.success(res.msg)
                    emit('ok')
                })
                .catch((res) => {
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
const onFormSubmit = () => {
    if (props.tableColumnsData.registration_type == 2) {
        message.error('该客户为裸地址，不支持同步资料')
        return
    }
    if (props.tableColumnsData.is_auto == 2) {
        message.error('资料还未确定，不支持同步资料')
        return
    }
    if (props.tableColumnsData.business_type != 1) {
        // getMigrateSmsCode()
        registerFormState.social_credit_code = props.tableColumnsData.social_credit_code
    }
    //过风控+检查资料完整性
    let promise = queryDetail()
    promise.then((res: any) => {
        let queryParam = {
            url: '/admin/v1/getDataVerificatioStatus?customer_id=' + props.tableColumnsData.id,
            method: 'get'
        }
        baseService(queryParam)
            .then((val: any) => {
                if (val.data.status == 1) {
                    modalConfirm()
                } else {
                    for (let item of val.data.msg) {
                        message.error(item)
                    }
                    return
                }
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
            })
    })
}
const modalConfirm = () => {
    if (props.tableColumnsData.business_type == 1) {
        data.openPushOrder = true
    } else {
        let param = {
            url: '/admin/v1/getAlterationQrcodeStatus?customer_id=' + props.tableColumnsData.id,
            method: 'get'
        }
        baseService(param)
            .then((res: any) => {
                data.openQrcode = true
                if (res.data.status == 1) {
                    data.openPushOrder = true
                } else if (registerFormState.type == 2) {
                    let queryParam = {
                        url: '/admin/v1/getAlterationQrcodeUrl?customer_id=' + props.tableColumnsData.id,
                        method: 'get'
                    }
                    baseService(queryParam)
                        .then((res: any) => {
                            timer.value = setInterval(() => {
                                let param = {
                                    url: '/admin/v1/getAlterationQrcodeStatus?customer_id=' + props.tableColumnsData.id,
                                    method: 'get'
                                }
                                baseService(param).then((res: any) => {
                                    if (res.data.status == 1) {
                                        qrcodeCancel()
                                        data.openPushOrder = true
                                    }
                                })
                            }, 3000)
                            data.openQrcode = true
                            data.deadline = Date.now() + 1000 * 120
                            data.qrcode = res.data.base64_image
                        })
                        .catch((res) => {
                            if (res.msg) {
                                message.error(res.msg)
                            } else {
                                message.error('操作失败')
                            }
                        })
                }
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
            })
    }
}
const onDocxClick = () => {
    //window.open('https://pan.baidu.com/s/18Mjh_XWTcwUY01_SbGiJfA?pwd=8888')
    window.open('https://hncs.cskaiyela.com/storage/public/uploads/manage/模板资料/202510/手持承诺书拍照范本.docx')
}
const editPhone = (index: number) => {
    shareOwnershipTableData[index].isEdit = true
}

// 修改手机号码
const editPhoneChange = (record) => {
    let phone = record.phone_number_faren ? record.phone_number_faren : record.phone_number
    let promise = mobileRequiredValidator({}, phone)
    promise
        .then(() => {
            let data: any = {
                action: 'changephone',
                phone_number: phone
            }
            if (record.stockholder_id) {
                data.stockholder_id = record.stockholder_id
            }
            if (record.persion_id) {
                data.persion_id = record.persion_id
            }
            let requestParam = {
                url: '/admin/v1/tuisongzuodan',
                method: 'post',
                data: data
            }
            baseService(requestParam)
                .then((res: any) => {
                    message.success(res.msg)
                    queryDetail(1)
                })
                .catch((res) => {
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        })
        .catch((res) => {
            message.error(res)
        })
}

const onVerification2Click = (val, record, index) => {
    console.log(record)
    affiliatedCompany = record.affiliatedCompany
}
// 查询核验记录
const onVerificationClick = (val, record, index) => {
    if (val) {
        heyanBenrentelData = []
        if (!record.name || !record.id_card_number || !record.phone_number) {
            message.error('请先编辑人员姓名和身份证号码和手机号码')
            return
        }
        verificationLoading.value = true
        telusedminrequired.value = 0
        let data = {
            action: 'heyan_benrentel',
            name: record.name,
            idcard: record.id_card_number,
            company_id: props.tableColumnsData.id,
            tel: record.phone_number
        }
        let requestParam = {
            url: '/admin/v1/heyan_benrentel',
            method: 'post',
            data: data
        }
        baseService(requestParam)
            .then((res) => {
                setTimeout(() => {
                    telusedminrequired.value = res.data.telusedminrequired
                    heyanBenrentelData = res.data.res
                    verificationLoading.value = false
                }, 500)
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
            })
    }
}
// 核验手机号
const onVerificationPhoneClick = (record, index) => {
    data.verifyPhoneLoading = true
    let postdata = {
        tel: record.phone_number,
        cid: props.tableColumnsData.id
    }
    let requestParam = {
        url: '/admin/v1/onlinetimecheck',
        method: 'post',
        data: postdata
    }
    baseService(requestParam)
        .then((res: any) => {
            data.verifyPhoneLoading = false
            message.success(res.msg)
            queryDetail()
            onVerificationClick(true, record, index)
        })
        .catch((res) => {
            data.verifyPhoneLoading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}

// const verificationDisabled = () => {
//   /* 成功 */
//   let successIndex: any = null
//   /* 失败 */
//   let errorIndex: any = null
//   heyanBenrentelData.forEach((element: any, index) => {
//     if (element.resmsg == '三要素身份验证一致') {
//       successIndex = index + 1
//     }
//     if (element.resmsg == '实名核验有误') {
//       errorIndex = index + 1
//     }
//   })
//   if (!successIndex) {
//     return true
//   } else if (successIndex && !errorIndex) {
//     return false
//   } else {
//     if (errorIndex > successIndex) {
//       return false
//     } else {
//       return true
//     }
//   }
// }
</script>

<style lang="less" scoped>
.positionItem {
    display: inline-block;
    margin: 5px 2px;
}

.phone_number {
    min-height: 61px;
    display: inline-block;
    line-height: 61px;
}

.ant-table-content {
    min-height: 230px;
}

.remark {
    display: flex;
    flex-direction: row-reverse;
}

.modal-title {
    display: flex;
    align-items: center;

    .InfoCircleOutlined {
        color: #faad14;
        flex: none;
        margin-inline-end: 12px;
        font-size: 22px;
    }

    .title {
        display: block;
        overflow: hidden;
        color: rgba(0, 0, 0, 0.88);
        font-weight: 600;
        font-size: 16px;
        line-height: 1.5;
    }
}
</style>
<style lang="less">
.order-verification-popover {
    width: 750px;

    .ant-popover-inner-content {
        min-height: 300px;
    }

    .ant-popover-title {
        line-height: 40px;
    }
}
</style>
